import { useState } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { NavTabs } from '@components/NavTabs';
import { useTranslation } from '@hooks';
import { RoutePath } from '@constants/routes';
import Conversion from './Conversion';
import Feedback from './Feedback';

const Container = styled('div')({
    '@media (max-width: 1024px)': {
        padding: '16px 16px 0',
        height: 'calc(var(--100vh) - 108px)',
        overflowY: 'auto',
    },
    '@media print': {
        height: 'auto',
        overflow: 'visible',
    },
});

const StyledNavTabs = styled(NavTabs)({
    '@media print': {
        display: 'none',
    },
});

const AnalyticsSurveysRoute = () => {
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState(pathname);
    const { t } = useTranslation();

    const availableTabs = [
        { label: t('Sidebar.analyticsConversion'), value: RoutePath.SurveysAnalyticsConversion },
        { label: t('Sidebar.analyticsSurveys'), value: RoutePath.SurveysAnalyticsResponses },
    ];

    const RouteMap = {
        [RoutePath.SurveysAnalyticsConversion]: 0,
        [RoutePath.SurveysAnalyticsResponses]: 1,
    };

    return (
        <Container>
            <StyledNavTabs
                tabLinks={availableTabs}
                onTabClick={selectedTab => setCurrentTab(selectedTab)}
                currentTabIndex={RouteMap[currentTab]}
            />
            <Switch>
                <Route path={RoutePath.SurveysAnalyticsConversion} component={Conversion} />
                <Route path={RoutePath.SurveysAnalyticsResponses} component={Feedback} />
                <Redirect from={RoutePath.SurveysAnalytics} to={RoutePath.SurveysAnalyticsConversion} />
            </Switch>
        </Container>
    );
};

export default AnalyticsSurveysRoute;
